import {Flex, Image, Text, useDisclosure} from '@chakra-ui/react';
import {colors} from 'components/providers';
import {UserOrdersModal} from 'components/shared';
import {useRouter} from 'next/router';
import {FC} from 'react';
import {TranslationKeys} from 'translations';
import {IOrder} from 'types';

interface IProps {
  t: (term: TranslationKeys) => string;
  ordersActive: IOrder[];
  orders: IOrder[];
  onHandlerSetLimit: () => void;
  isLoadingOrders: boolean;
}

export const ActiveOrders: FC<IProps> = ({t, ordersActive, orders, onHandlerSetLimit, isLoadingOrders}) => {
  const {push} = useRouter();
  const {isOpen, onOpen, onClose} = useDisclosure();
  const activeOrderFirst = ordersActive.length > 0 && ordersActive[0];
  if (!activeOrderFirst) return null;
  const price = activeOrderFirst.money.order_total;

  const onClickHandler = () => {
    if (ordersActive.length === 1) {
      push(`/order/${activeOrderFirst.uuid}`);
    } else if (ordersActive.length > 1) {
      onOpen();
    }
  };

  return (
    <Flex w="100%" justifyContent="space-between" onClick={onClickHandler} h={['40px', 'auto']} alignItems="center">
      <Text fontSize={['16px', '24px']}>
        {price} {t('CURRENCY')}
      </Text>
      <Text fontSize={['16px', '24px']} textAlign="center">
        {t('ACTIVE_ORDERS')}
      </Text>
      <Flex alignItems="center">
        <Image w={['25px', '30px']} h={['25px', '30px']} src="/icons/activeOrderIcon.svg" alt="icon" />
        <Flex
          justifyContent="center"
          alignItems="center"
          bg={colors.pink}
          boxSize={['25px', '30px']}
          borderRadius="50%"
          border="1px solid white"
          ml="10px"
        >
          <Text
            fontSize={['12px', '18px']}
            w={['25px', '30px']}
            color="white"
            textAlign="center"
            justifyContent="center"
          >
            {ordersActive.length}
          </Text>
        </Flex>
      </Flex>
      {isOpen && (
        <UserOrdersModal
          orders={orders}
          onHandlerSetLimit={onHandlerSetLimit}
          isLoadingOrders={isLoadingOrders}
          isOpen={isOpen}
          onClose={onClose}
        />
      )}
    </Flex>
  );
};
